import { AppIcon } from '@linktr.ee/arbor/components/AppIcon';
import React from 'react';
import Button from './Button';

interface SocialButtonProps {
  provider: 'google' | 'apple';
  onClick: () => void;
  children: React.ReactNode;
  className?: string;
  loading?: boolean;
}

const SocialButton: React.FC<SocialButtonProps> = ({
  provider,
  onClick,
  children,
  className = '',
  loading = false,
}) => {
  const getProviderIcon = () => {
    switch (provider) {
      case 'google':
        return <AppIcon app="google" size={20} />;
      case 'apple':
        // Optical alignment: the apple glyph's visual mass sits low in its
        // box (the leaf reads as whitespace), so box-centering makes it look
        // sunk next to the label's cap height. Nudge it up to compensate.
        return (
          <AppIcon
            app="apple"
            size={20}
            variant="mono"
            className="-translate-y-px"
          />
        );
      default:
        return null;
    }
  };

  const providerIcon = getProviderIcon();

  return (
    <Button
      onClick={onClick}
      label={children as string}
      icon={providerIcon || undefined}
      state={loading ? 'loading' : 'default'}
      className={className}
    />
  );
};

export default SocialButton;
